import { useEffect, useState } from 'react';
import { contentCards } from '@origin-digital/event-dispatcher';
import { logger, abTest, IAbTestDataType } from '@origin-digital/reporting-client';

import { LOCATIONS } from '../../consts/config';

export interface IAbTestValue {
  cohort?: 'a' | 'b';
  loading: boolean;
}

export const useAbTest = (
  location: string,
  category: string,
  type: IAbTestDataType,
): IAbTestValue => {
  const [abTestValue, setABTestValue] = useState<IAbTestValue>({ loading: true });

  useEffect(() => {
    (async () => {
      const startTimer = Date.now();

      const contentCard = await contentCards({
        location,
        limit: 1,
        timeout: 3000, // 3 secs
      });

      const { unknownUser, timeout, cards } = contentCard ?? {};
      const cohort = cards?.[0]?.title;
      const experienceId = cards?.[0]?.experienceId ?? 'experienceId not found';

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const sendAnalytics = (object: any) => {
        const { card, ...rest } = object;
        logger.info('braze ab test', { cohort, location, ...rest });
        if (card) {
          abTest('braze', {
            type,
            location,
            experienceId,
          });
        }
      };

      if (cohort === 'a' || cohort === 'b') {
        const timer = Date.now() - startTimer;
        const card = { id: experienceId, category, title: location };
        cards?.[0]?.logImpression?.();
        setABTestValue({ cohort, loading: false });
        sendAnalytics({ timer, success: true, experienceId, card });
      } else if (unknownUser) {
        setABTestValue({ loading: false });
        sendAnalytics({ success: false, unknownUser, timeout });
      } else {
        // try again with more forceRefresh and more time
        const contentCard2 = await contentCards({
          location,
          forceRefresh: true,
          timeout: 5000,
        });
        const success = !!contentCard2.cards[0]?.title;
        const timer = Date.now() - startTimer;
        setABTestValue({ loading: false });
        sendAnalytics({ success, timeout, timer, attempt2: true });
      }
    })();
  }, [location]);

  return abTestValue;
};

// Example of abTest usage

// export const useAbQuickLinks = () => {
//   const abTest = useAbTest(LOCATIONS.abTestQuickLinks, 'homepage-quicklinks', 'component');
//   if (abTest.cohort === 'b') {
//     return QUICK_LINKS_B;
//   } else {
//     return undefined;
//   }
// };

export const useAbProductQuickLinks = () => {
  useAbTest(LOCATIONS.abTestProductQuickLinks, 'homepage-productquicklinks', 'component');
};
